module.exports = __webpack_public_path__ + "img/about_bg_image@2x.521f25c5.png";